// extracted by mini-css-extract-plugin
export default {"monthly-summary-box":"monthlySummary_monthly-summary-box__QEgji","monthly-summary":"monthlySummary_monthly-summary__kVqY-"};